export const dateRange = {
  DateFilter_Option_Custom: _TL_('Custom'),
  DateFilter_Option_CustomTime: _TL_('Time'),
  DateFilter_Option_Today: _TL_('Today'),
  DateFilter_Option_Yesterday: _TL_('Yesterday'),
  DateFilter_Option_ThisWeekSunday: _TL_('This week (Sun - Today)'),
  DateFilter_Option_ThisWeekMonday: _TL_('This week (Mon - Today)'),
  DateFilter_Option_Last7days: _TL_('Last 7 days'),
  DateFilter_Option_LastWeekSunday: _TL_('Last week (Sun - Sat)'),
  DateFilter_Option_LastWeekMonday: _TL_('Last week (Mon - Sun)'),
  DateFilter_Option_Last14Days: _TL_('Last 14 days'),
  DateFilter_Option_ThisMonth: _TL_('This month'),
  DateFilter_Option_LastMonth: _TL_('Last month'),
  DateFilter_Option_Last30Days: _TL_('Last 30 days'),
  DateFilter_Option_Last3Months: _TL_('Last 3 months'),
  DateFilter_Option_Last6Months: _TL_('Last 6 months'),
  DateFilter_Option_TwelveMonthsToDate: _TL_('Rolling year'),
  DateFilter_Option_ThisYear: _TL_('This year'),
  DateFilter_Option_LastYear: _TL_('Last year'),
  DateFilter_Option_AllTime: _TL_('Entire time'),
  DateFilter_Option_PreviousPeriod: _TL_('Previous period'),
  DateFilter_Option_SamePeriodLastYear: _TL_('Same period last year'),
  DateFilter_Option_CustomPeriod: _TL_('Custom'),
};
